import Abstract from "../../abstract-view/abstract.js";

import {
  createElement
} from "../../render/render.js";

const createModalTemplate = () => {
  return (
    `<section class="categories-modal" style="display: none;">
      <div class="categories-modal-container">
        <div class="categories-modal-heading-wrapper">
          <div class="container">
            <div class="categories-heading-container">
              <h2 class="categories-modal__heading">Категории</h2>
              <button class="categories-modal__close">
                <span class="visually-hidden">Закрыть</span>
              </button>
            </div>
          </div>
        </div>
        <div class="container container_subcategories">
        </div>
      </div>
    </section>`
  );
};

export default class Modal extends Abstract {
  constructor() {
    super();

    this._closeButton = null;
    this._modalContainer = null;
    this._subcategoriesContainer = null;

    this._sectionClickHandler = this._sectionClickHandler.bind(this);
    this._closeButtonClickHandler = this._closeButtonClickHandler.bind(this);
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this._getTemplate());
    }

    return this._element;
  }

  getModalContainer() {
    if (!this._modalContainer) {
      this._modalContainer = this._element.querySelector(`.categories-modal-container`);
    }

    return this._modalContainer;
  }

  getSubcategoriesContainer() {
    if (!this._subcategoriesContainer) {
      this._subcategoriesContainer = this._element.querySelector(`.container_subcategories`);
    }

    return this._subcategoriesContainer;
  }

  getCloseButton() {
    if (!this._closeButton) {
      this._closeButton = this._element.querySelector(`.categories-modal__close`);
    }

    return this._closeButton;
  }

  setSectionClickHandler(callback) {
    this._callback.sectionClick = callback;
    this.getElement().addEventListener(`click`, this._sectionClickHandler);
  }

  setCloseButtonClickHandler(callback) {
    this._callback.closeButtonClick = callback;
    this.getCloseButton().addEventListener(`click`, this._closeButtonClickHandler);
  }

  _getTemplate() {
    return createModalTemplate();
  }

  _sectionClickHandler(evt) {
    this._callback.sectionClick(evt);
  }

  _closeButtonClickHandler() {
    this._callback.closeButtonClick();
  }
}
